function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m.333252 0h32v32h-32z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  fill: "#303030"
}, /*#__PURE__*/React.createElement("path", {
  d: "m22.6685 14.5541c1.6862 0 3.0289 1.2929 2.9976 2.9327v2.7606c0 2.8039-2.273 5.0769-5.0769 5.0769-.701 0-1.2692-.5682-1.2699-1.2692-.0006-.6879-.0017-1.3759-.0027-2.0638-.0012-.7779-.0025-1.5558-.0028-2.3337-.0014-1.3805-.0012-2.7611.0036-4.1416.0014-.3772.2139-.7283.5736-.8419.2082-.0656.4439-.12.6541-.12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.4115 13.9245v10.0665c0 .7364-.5969 1.3333-1.3333 1.3333h-4.7449c-2.94548 0-5.3333-2.3878-5.3333-5.3333v-6.0633c0-.1366.02454-.2735.09473-.3907.51465-.8595 1.90551-1.5174 2.50158-1.7685.18006-.0758.37867-.0869.56879-.042l.3094.0731c.5024.1187.8318.6003.7604 1.1116l-.542 3.8805c-.0398.2849.1814.5391.469.5391.2628 0 .4754.2141.4735.477l-.0014.1983c-.0027.3721.2982.6752.6703.6752h.7832c.3853 0 .6976-.3123.6976-.6976v-.1797c0-.2663.2065-.4869.4722-.5045.293-.0195.5078-.2837.4672-.5745l-.5358-3.8332c-.0739-.5283.2801-1.0217.8043-1.1209l.2813-.0533c.1766-.0335.3579-.0195.5238.0497.5785.2411 1.9845.8957 2.5142 1.7574.0733.1193.0992.2597.0992.3998z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.4 8.65c0 1.4636-1.1865 2.65-2.65 2.65-1.4636 0-2.65-1.1864-2.65-2.65 0-1.46355 1.1864-2.65 2.65-2.65 1.4635 0 2.65 1.18645 2.65 2.65z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.3 10.65c0 1.4636-1.1864 2.65-2.65 2.65s-2.65-1.1864-2.65-2.65c0-1.46355 1.1864-2.65 2.65-2.65s2.65 1.18645 2.65 2.65z"
}));

function SvgLawFirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 33 32",
    width: 33
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,";
export { SvgLawFirm as ReactComponent };